export default class BrowserDetect {
    /**
     * Internet Explorer 6-11
     * @returns {Boolean}
     */
    static isIE() {
        return /*@cc_on!@*/ false || !!document.documentMode;
    }

    /**
     * MS Edge 20+
     * @returns {Boolean}
     */
    static isEdge() {
        return !self.isIE() && !!window.StyleMedia;
    }

    /**
     * Firefox 1.0+
     * @returns {Boolean}
     */
    static isFirefox() {
        return typeof InstallTrigger !== 'undefined';
    }

    /**
     * Chrome 1-79
     * @returns {Boolean}
     */
    static isChrome() {
        return !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    }

    /**
     * Safari 3.0+ "[object HTMLElementConstructor]"
     * @returns {Boolean}
     */
    static isSafari() {
        return /constructor/i.test(window.HTMLElement) ||
        (function(p) {
            return p.toString() === '[object SafariRemoteNotification]';
        })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
    }

    /**
     * Opera 8.0+
     * @returns {Boolean}
     */
    static isOpera() {
        return (!!window.opr && !!opr.addons) ||
        !!window.opera ||
        navigator.userAgent.indexOf(' OPR/') >= 0;
    }
}
